import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';

import moment from 'moment';

@Component({
  selector: 'app-service-purchase-order-header',
  templateUrl: './service-purchase-order-header.component.html',
  styleUrls: ['./service-purchase-order-header.component.css']
})


export class ServicePurchaseOrderHeaderComponent implements OnInit {


  firstFormGroup!: UntypedFormGroup;

  isForm1Expand: boolean = true;
  isForm2Expand: boolean = true;
  isForm3Expand: boolean = true;
  isForm4Expand: boolean = true;
  isForm5Expand: boolean = true;
  isForm6Expand: boolean = true;

  headerData: any;
  showConfirmationDialogue: boolean = false;
  showSuccessDialogue: boolean = false;
  showCloseDialogue: boolean = false;

  tabs: any[] = [
    {
      index: 0,
      label: 'LINE ITEMS',
      icon: "directions_boat",
      route: 'line-items',
    },
    {
      index: 1,
      label: 'HEADER DETAILS',
      icon: "looks",
      route: 'header',
    },
    {
      index: 2,
      label: 'PAYMENT TERMS',
      icon: "location_searching",
      route: 'payment-terms',
    }, {
      index: 3,
      label: 'PREVIEW',
      icon: "location_searching",
      route: 'preview',
    }
  ];

  currentTab: string = 'header';
  serviceRfqId!: number;
  quoteId!: any;
  servicePurchaseOrderId!: any;
  isSaved: boolean = false;

  constructor(
    private snack: MatSnackBar,
    private _formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private cookieService: CookieService,
    private router: Router,
    private settingsService: SettingsService,
    private fullLoaderService: FullLoaderService,
    private activatedRoute: ActivatedRoute,
  ) {
  };


  async ngOnInit() {

    this.fullLoaderService.showLoader();

    this.firstFormGroup = this._formBuilder.group({
      // Purchase Order Details
      purchaseOrderRefNumber: [''],
      purchaseOrderDate: [''],
      rfqRefNumber: [''],
      rfqDate: [''],
      quoteRefNumber: [''],
      quotationDate: [''],
      expectedDeliveryDate: [''],

      // Buyer Company Details
      buyerName: [''],
      buyerEmail: [''],
      buyerPhone: [''],
      buyerFax: [''],
      buyerAddress: [''],

      // Buyer Details
      buyerContactPerson: [''],
      buyerContactEmail: [''],
      buyerContactPhone: [''],
      buyerContactFax: [''],
      buyerContactAddress: [''],

      // Supplier Details
      supplierContactName: [''],
      supplierEmail: [''],
      supplierPhone: [''],
      supplierFax: [''],
      supplierCompanyEmail: [''],

      // Vessel Details (4 fields — no hullNumber, yardName, yearBuilt)
      vesselName: [''],
      vesselIMONumber: [''],
      vesselType: [''],
      vesselClass: [''],

      // Port Details (no vesselETB, vesselEtbTime)
      portName: [''],
      portCode: [''],
      vesselETA: [''],
      vesselETD: [''],
      vesselEtaTime: [new Date()],
      vesselEtdTime: [new Date()],
    });


    const params = this.activatedRoute.snapshot.queryParams;

    if (params['serviceRfqId'] != '' && params['quoteId'] != '' && params['servicePurchaseOrderId'] != '') {

      this.serviceRfqId = params['serviceRfqId'];
      this.quoteId = params['quoteId'];
      this.servicePurchaseOrderId = params['servicePurchaseOrderId'];

      this.isSaved = true;

      let fetchParams = {
        purchaseOrderId: this.servicePurchaseOrderId,
        section: "header"
      };
      const result = await this.settingsService.fetchServicePurchaseOrder(fetchParams);
      const data = result[0];
      console.log({ data });

      this.firstFormGroup.patchValue({
        // Purchase Order Details
        purchaseOrderRefNumber: data.purchaseOrderRefNumber || '',
        purchaseOrderDate: data.purchaseOrderDate || '',
        rfqRefNumber: data.rfqRefNumber || '',
        rfqDate: data.rfqDate || '',
        quoteRefNumber: data.quoteRefNumber || '',
        quotationDate: data.quotationDate || '',
        expectedDeliveryDate: data.expectedDeliveryDate || '',

        // Buyer Company Details
        buyerName: data.buyerCompanyName || '',
        buyerEmail: data.companyEmailId || '',
        buyerPhone: data.companyPhoneNumber || '',
        buyerFax: data.companyFax || '',
        buyerAddress: data.companyAddress || '',

        // Buyer Details
        buyerContactPerson: data.buyerContactPerson || '',
        buyerContactEmail: data.buyerEmail || '',
        buyerContactPhone: data.buyerPhone || '',
        buyerContactFax: data.buyerFax || '',
        buyerContactAddress: data.buyerAddress || '',

        // Supplier Details
        supplierContactName: data.supplierContactPerson || data.supplierName || '',
        supplierEmail: data.supplierEmail || '',
        supplierPhone: data.supplierPhone || '',
        supplierFax: data.supplierFax || '',
        supplierCompanyEmail: data.supplierCompanyEmail || data.supplierEmail || '',

        // Vessel Details
        vesselName: data.vesselName || '',
        vesselIMONumber: data.vesselImoNumber || '',
        vesselType: data.vesselType || '',
        vesselClass: data.class || '',

        // Port Details
        portName: data.portName || '',
        portCode: data.portCode || '',
        vesselETA: data.vesselEta || '',
        vesselETD: data.vesselEtd || '',
        vesselEtaTime: data.vesselEtaTime ? this.convertTimeStringToDate(data.vesselEtaTime) : new Date(),
        vesselEtdTime: data.vesselEtdTime ? this.convertTimeStringToDate(data.vesselEtdTime) : new Date(),
      });

    }

    this.fullLoaderService.hideLoader();

  }


  convertTimeStringToDate(timeString: string): Date {
    if (!timeString) return new Date();

    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, seconds, 0);
    return date;
  }


  async save(isDraft?: boolean) {

    if (isDraft) {
      this.showConfirmationDialogue = false;
      this.showCloseDialogue = false;
    }

    this.fullLoaderService.showLoader();

    const dateString1 = this.firstFormGroup.value.vesselETA ? moment(this.firstFormGroup.value.vesselETA).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
    const dateString2 = this.firstFormGroup.value.vesselETD ? moment(this.firstFormGroup.value.vesselETD).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
    const dateString3 = this.firstFormGroup.value.expectedDeliveryDate ? moment(this.firstFormGroup.value.expectedDeliveryDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;

    const timeString1 = this.firstFormGroup.value.vesselEtaTime
      ? moment(this.firstFormGroup.value.vesselEtaTime).format("YYYY-MM-DDTHH:mm:ss") + "Z"
      : null;

    const timeString2 = this.firstFormGroup.value.vesselEtdTime
      ? moment(this.firstFormGroup.value.vesselEtdTime).format("YYYY-MM-DDTHH:mm:ss") + "Z"
      : null;

    this.firstFormGroup.patchValue({
      vesselETA: dateString1,
      vesselETD: dateString2,
      vesselEtaTime: timeString1,
      vesselEtdTime: timeString2,
      expectedDeliveryDate: dateString3,
    });

    const params1 = {
      section: 'header',
      purchaseOrderStatus: 14,
      purchaseOrderTabId: 2,
      purchaseOrderId: this.servicePurchaseOrderId,
      quoteId: this.quoteId,
      serviceRfqId: this.serviceRfqId,
      userId: Number(this.cookieService.get('userId')),
      vesselETA: this.firstFormGroup.get('vesselETA')?.value,
      vesselETD: this.firstFormGroup.get('vesselETD')?.value,
      vesselEtaTime: this.firstFormGroup.get('vesselEtaTime')?.value,
      vesselEtdTime: this.firstFormGroup.get('vesselEtdTime')?.value,
      expectedDeliveryDate: this.firstFormGroup.get('expectedDeliveryDate')?.value,
    };

    await this.settingsService.updateServicePurchaseOrder(params1);

    if (isDraft) {
      this.router.navigate(['/operations/purchase-order-list'], {
        queryParams: {
          selectedStatus: 'Draft',
          label: 'Order'
        }
      });
    }

    this.fullLoaderService.hideLoader();

  }


  async close(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true;
    }
    else {
      this.showCloseDialogue = true;
    }
  }

  cancel() {
    this.showConfirmationDialogue = false;
    this.showCloseDialogue = false;
    this.router.navigate(['/operations/buyer-service-quote-list']);
  }


  next() {
    this.activatedRoute.queryParams.subscribe(async params => {

      if (params['serviceRfqId'] != '' && params['quoteId'] != '' && params['servicePurchaseOrderId'] != '') {

        this.serviceRfqId = params['serviceRfqId'];
        this.quoteId = params['quoteId'];
        this.servicePurchaseOrderId = params['servicePurchaseOrderId'];

        this.router.navigate([
          "operations", "createServiceOrder", 'payment-terms'
        ],
          {
            queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId, servicePurchaseOrderId: this.servicePurchaseOrderId }
          }
        );

      }

    });
  }

  async back() {
    this.activatedRoute.queryParams.subscribe(async params => {

      if (params['serviceRfqId'] != '' && params['quoteId'] != '' && params['servicePurchaseOrderId'] != '') {

        this.serviceRfqId = params['serviceRfqId'];
        this.quoteId = params['quoteId'];
        this.servicePurchaseOrderId = params['servicePurchaseOrderId'];

        this.router.navigate([
          "operations", "createServiceOrder", 'line-items'
        ],
          {
            queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId, servicePurchaseOrderId: this.servicePurchaseOrderId }
          }
        );

      }

    });
  }

  toggleVisibility(section: string) {
    if (section == 'form1') {
      this.isForm1Expand = !this.isForm1Expand;
    }
    else if (section == 'form2') {
      this.isForm2Expand = !this.isForm2Expand;
    }
    else if (section == 'form3') {
      this.isForm3Expand = !this.isForm3Expand;
    }
    else if (section == 'form4') {
      this.isForm4Expand = !this.isForm4Expand;
    }
    else if (section == 'form5') {
      this.isForm5Expand = !this.isForm5Expand;
    }
    else if (section == 'form6') {
      this.isForm6Expand = !this.isForm6Expand;
    }
  }


  async selectMatTabLink(tabItem: any) {
    try { await this.save(); } catch (e) { console.error('Auto-save failed:', e); }
    this.fullLoaderService.showLoader();

    if (tabItem.route == 'line-items') {
      this.back();
    }
    else if (tabItem.route == 'payment-terms') {
      this.next();
    } else if (tabItem.route == 'preview') {
      this.activatedRoute.queryParams.subscribe(async params => {

        if (params['serviceRfqId'] != '' && params['quoteId'] != '' && params['servicePurchaseOrderId'] != '') {

          this.serviceRfqId = params['serviceRfqId'];
          this.quoteId = params['quoteId'];
          this.servicePurchaseOrderId = params['servicePurchaseOrderId'];

          this.router.navigate([
            "operations", "createServiceOrder", 'preview'
          ],
            {
              queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId, servicePurchaseOrderId: this.servicePurchaseOrderId }
            }
          );

        }

      });
    }
  }

}
